import React, { useState, useEffect, useMemo } from "react";
import SockJS from "sockjs-client";
import { Client } from "@stomp/stompjs";
import moment from "moment";
import { useLocation } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import ChatHeader from "./ChatHeader";
import ChatList from "./ChatList";
import storage from "../../../utils/storage";
import MessageListPanel from "./MessageListPanel";
import ChatInput from "./ChatInput";
import { useDispatch, useSelector } from "react-redux";
import appActions from "../../../appActions";
import Sidebar from "../../../components/Sidebar";
import axios from "axios";
import { showToast } from "../../../utils/toastActions";
import Loader from '../../../components/Loader';
const configOpiton = window && window.config;

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};

const ChatInterface = () => {
    const query = useQuery();
    const urlConnectionId = query.get("connectionId");
    const loginId = storage.get("userId");

    const dispatch = useDispatch();

    const [stompClient, setStompClient] = useState(null);
    const [messageList, setMessageList] = useState([]);
    const [selectedChat, setSelectedChat] = useState({});
    const [chatGroupList, setChatGroupList] = useState([]);
    const [isConnected, setIsConnected] = useState(false);

    const [pageSize, setPageSize] = useState(10)
    const [pageno, setPageNo] = useState(1)

    const connectionId = urlConnectionId ? urlConnectionId : loginId;
    const httpMessages = useSelector((state) => state.chat.messageList);
    const totalRecords = useSelector((state) => state?.chat?.totalRecords);

    const userInfo = useMemo(() => JSON.parse(storage.get("loginUser")), []);
    const storeId = userInfo.siteId;

    const chatUser = storage.get("chatUser");
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        connect();
    }, []);

    const params = {
        date_from: moment().subtract(7, "days").format("YYYY-MM-DD"),
        date_till: moment().format("YYYY-MM-DD"),
        userId: connectionId,
        msgcondi: "all",
        sendtoId: connectionId,
        msgcondi: "all",
    };

    useEffect(() => {
        // if (!chatUser || chatUser !== connectionId) {
            getUserMessageList(10, 1);
        // }
        if (chatUser && chatUser == connectionId) {
            const chatItemList = JSON.parse(storage.get("chatGroup")) || [];
            // setChatGroupList(chatItemList);
            if (chatItemList.length > 0) {
                setSelectedChat(chatItemList[chatItemList.length - 1]);
            }
            const savedMessages =
                JSON.parse(localStorage.getItem("messages")) || [];
            setMessageList(savedMessages);
        }
        
    }, []);

    const getUserMessageList = (pagesize, pageno) => {
        params["pagesize"] = pagesize;
        params["pageno"] = pageno;
        dispatch(appActions.MESSAGE_GET_ALL_REQUEST(params));
    };

    //get storage size
    const getLocalStorageSize = () => {
        let totalSize = 0;

        for (let key in localStorage) {
            if (localStorage.hasOwnProperty(key)) {
                const keySize = key.length;
                const valueSize = localStorage.getItem(key).length;
                totalSize += keySize + valueSize;
            }
        }
        const totalSizeInBytes = totalSize * 2;
        return totalSizeInBytes;
    };

    const isSameUser = () => {
        if (!chatUser || chatUser !== connectionId) {
            return false
        }
        return true
    }

    useEffect(() => {

        if (totalRecords === 0) {
            setLoading(false);
            return;
        }
    
        // Sort and add messages to the list
        const sortedMessages = httpMessages.sort((a, b) => a.offsetId - b.offsetId);
        sortedMessages.forEach(addMessageToList);
    
        // Filter messages sent to valid users and process user-specific messages
        const validMessages = sortedMessages.filter((msg) => msg.sendtoId !== "");
        const userMessages = validMessages.reduce((acc, item) => {
            const isCurrentUser =
                item.userId === connectionId || item.sendtoId === connectionId;
            if (!isCurrentUser) return acc;
    
            const chatId = item.userId === connectionId ? item.msgGroup ? item.msgGroup : item.sendtoId : item.msgGroup ? item.msgGroup : item.userId;
            const existingMessage = acc[chatId];
    
            // If there's no existing message or this one is more recent, update the message
            if (
                !existingMessage ||
                new Date(item.createdOn) > new Date(existingMessage.msgTime)
            ) {
                acc[chatId] = {
                    chatId,
                    message: item.message,
                    msgTime: item.createdOn,
                };
            }
            return acc;
        }, {});
    
        // Convert object to array and filter out any invalid chatId entries
        const updatedResult = Object.values(userMessages).filter(
            (res) => res.chatId.length > 0
        );
    
        // Update state and localStorage
        setChatGroupList(updatedResult);
        if(updatedResult.length > 0) {
            setSelectedChat(updatedResult[updatedResult.length - 1]);
        }
        storage.set("chatUser", connectionId);
    
        // if (!isSameUser()) {
            storage.set("chatGroup", JSON.stringify(updatedResult));
        // }
    
        // Pagination handling
        if (httpMessages.length != totalRecords) {
            const nextPage = pageno + 1;
            setPageNo(nextPage);
            getUserMessageList(pageSize, nextPage);
        }
        else {
            setLoading(false);
        }
    }, [httpMessages, totalRecords]);

    const defaultParams = {
        date_from: moment().subtract(7, "days").format("YYYY-MM-DD"),
        date_till: moment().format("YYYY-MM-DD"),
        userId: connectionId,
        msgcondi: "all",
    };

    const getUserMessage = () => {
        const { chatId } = selectedChat;
        if (chatId) {
            defaultParams["sendtoId"] = chatId;
            dispatch(appActions.MESSAGE_GET_ALL_REQUEST(defaultParams));
        }
    };

    useEffect(() => {
        if (stompClient) {
            stompClient.onConnect = onConnected;
            stompClient.onStompError = onError;
            stompClient?.activate();
        }
    }, [stompClient]);

    const onDisconnected = () => {
        setIsConnected(false);
    };

    useEffect(() => {
        if (isConnected) {
            const interval = setInterval(() => {
                ping();
            }, 5000);
            return () => clearInterval(interval);
        }
    }, [isConnected]);

    const connect = () => {
        const socket = new SockJS(`${configOpiton?.END_POINT}/websocket`);
        const client = new Client({
            webSocketFactory: () => socket,
            reconnectDelay: 5000,
            onConnect: onConnected,
            onDisconnect: onDisconnected,
        });
        client.activate();
        setStompClient(client);
    };

    const onConnected = () => {
        if (stompClient?.connected) {
            stompClient?.subscribe(
                `/consumer/${connectionId}/receive`,
                onMessageReceived,
            );
            setIsConnected(true);

            const msg = {
                header: {
                    eventtype: "connect",
                    connectionId: connectionId,
                    storeId: storeId,
                },
            };

            stompClient?.publish({
                destination: `/producer/${connectionId}/send`,
                body: JSON.stringify(msg),
            });
        }
    };

    const ping = () => {
        if (!stompClient?.connected) {
            console.error("Cannot ping. STOMP client is not connected.");
            return;
        }

        const msg = {
            header: {
                eventtype: "ping",
                connectionId: connectionId,
                storeId: storeId,
            },
        };

        stompClient?.publish({
            destination: `/producer/${connectionId}/send`,
            body: JSON.stringify(msg),
        });
    };

    const onError = (error) => {
        const msg = {
            header: {
                eventtype: "error",
            },
            body: {
                error,
            },
        };

        stompClient?.publish({
            destination: `/producer/${connectionId}/send`,
            body: JSON.stringify(msg),
        });

        console.log(
            "Could not connect to WebSocket server. Please refresh this page to try again!" +
                error,
        );
    };

    const isMessage = (msg) => {
        return msg.message ? true : false;
    };

    const addMessageToList = (newMessage) => {
        setMessageList((prevMessages) => {
            const messageExists = prevMessages.some(
                (msg) => msg.msgUuid === newMessage.msgUuid,
            );
            if (!messageExists) {
                const updatedMessages = [...prevMessages, newMessage];
                localStorage.setItem(
                    "messages",
                    JSON.stringify(updatedMessages),
                );
                return updatedMessages;
            } else if (messageExists) {
                const updatedMessages = prevMessages.map((msg) => {
                    if (msg.msgUuid === newMessage.msgUuid) {
                        return {
                            ...msg,
                            read: newMessage.read,
                            received: newMessage.received,
                        };
                    }
                    return msg;
                });
                localStorage.setItem(
                    "messages",
                    JSON.stringify(updatedMessages),
                );
                return updatedMessages;
            }
            return prevMessages;
        });

        setMessageList((prevMessages) => prevMessages.sort((a, b) => a.offsetId - b.offsetId));
    };

    const onMessageReceived = (payload) => {
        const message = JSON.parse(payload.body);
        if (message.header.eventtype === "message" && message.body) {
            if (Array.isArray(message.body) && message.body.length > 0) {
                message.body
                    .sort((a, b) => a.offsetId - b.offsetId)
                    .map((msg) => {
                        if (isMessage(msg) || msg.attached == "Y") {
                            addMessageToList(msg);
                            updateChatList(msg);
                        } else {
                            const localListing = JSON.parse(
                                localStorage.getItem("messages"),
                            );
                            if (localListing && localListing.length > 0) {
                                const index = localListing.findIndex(
                                    (cg) => cg.msgUuid === msg.msgUuid,
                                );
                                if (index !== -1) {
                                    localListing[index] = {
                                        ...localListing[index],
                                        offsetId: msg.offsetId,
                                        received: msg.received,
                                        read: msg.read,
                                    };
                                }
                                storage.set(
                                    "messages",
                                    JSON.stringify(localListing),
                                );
                                setMessageList(localListing);
                            }
                        }
                    });
            }
        }
    };

    const createdTopic = useSelector((state) => state.chat.createdTopic);

    useEffect(() => {
        if (createdTopic && createdTopic.id) {
            handleChatGroupCreated();
        }
    }, [createdTopic]);

    const handleChatGroupCreated = () => {
        const { topicId } = createdTopic;
        const currentList = [...chatGroupList];
        currentList.push({
            chatId: topicId,
            message: "",
            msgTime: moment().format("YYYY-MM-DD HH:mm:ss"),
            groupChat: true,
            userId: connectionId,
            chatUserName: topicId,
        });
        storage.set("chatGroup", JSON.stringify(currentList));
        setChatGroupList(currentList);
        dispatch(appActions.TOPIC_RESET_REQUEST());
    };

    const updateChatList = (msg) => {
        const { createdOn, message, msgGroup, userId, offsetId, sendtoId } =
            msg;
        const currentList = JSON.parse(storage.get("chatGroup")) || [];

        const updateChat = (index, isGroupChat) => {
            currentList[index] = {
                ...currentList[index],
                message: message != '' ? message : msg.attached == 'Y' ? '<Attachment>' : '',
                msgTime: createdOn || moment().format("YYYY-MM-DD HH:mm:ss"),
                groupChat: isGroupChat,
            };
        };

        const addChat = (isGroupChat) => {
            if (userId != userInfo.userId) {
                currentList.push({
                    chatId: msgGroup || userId,
                    message: message != '' ? message : msg.attached == 'Y' ? '<Attachment>' : '',
                    msgTime:
                        createdOn || moment().format("YYYY-MM-DD HH:mm:ss"),
                    groupChat: isGroupChat,
                    userId,
                });
            }
            else if (isGroupChat) {
                currentList.push({
                    chatId: msgGroup || userId,
                    message: message != '' ? message : msg.attached == 'Y' ? '<Attachment>' : '',
                    msgTime:
                        createdOn || moment().format("YYYY-MM-DD HH:mm:ss"),
                    groupChat: isGroupChat,
                    userId,
                });
            }
        };

        const index = !offsetId
            ? currentList.findIndex(
                  (cg) => cg.chatId === (msgGroup || sendtoId || userId),
              )
            : currentList.findIndex((cg) => cg.chatId === (msgGroup || userId || sendtoId));

        if (index !== -1) {
            updateChat(index, !!msgGroup);
        } else {
            addChat(!!msgGroup);
        }

        storage.set("chatGroup", JSON.stringify(currentList));
        setChatGroupList(currentList);
    };

    const handlePing = (offsetId) => {
        if(isConnected) {
            const msg = {
                header: {
                    eventtype: "message",
                    action: "offset-update",
                },
                body: [
                    {
                        offsetId: offsetId,
                        read: "Y",
                        received: "Y",
                    },
                ],
            };

            const destination = `/producer/${connectionId}/send`;

            // Publish the message
            stompClient?.publish({
                destination: destination,
                body: JSON.stringify(msg),
            });
        }
    };

    const sendMessage = (message, files) => {
        if (!stompClient?.connected) {
            console.error(
                "Cannot send message. STOMP client is not connected.",
            );
            return;
        }

        const msgUuid = uuidv4();

        const sentMessage = {
            userId: connectionId,
            msgBody: message,
            msgUuid: msgUuid,
            msgGroup: "",
            received: "N",
            read: "N",
            attached: "N",
            attachedFiles: null,
        };
        if (selectedChat.groupChat) {
            sentMessage["msgGroup"] = selectedChat.chatId;
        } else {
            sentMessage["sendToId"] = selectedChat.chatId;
        }

        if (files && files.length) {
            sentMessage["attached"] = "Y";
            // sentMessage["attachedFiles"] = [file];
        }

        const msg = {
            header: {
                eventtype: "message",
                action: "save",
            },
            body: [sentMessage],
        };

        let currMessage = sentMessage;
        currMessage["message"] = sentMessage.msgBody;
        currMessage["sendtoId"] = selectedChat.chatId;

        

        stompClient?.publish({
            destination: `/producer/${connectionId}/send`,
            body: JSON.stringify(msg),
        });

        if (files && files.length) {
            saveFiles(files, sentMessage?.msgUuid, currMessage, connectionId, selectedChat.chatId);
        }else{
            addMessageToList(currMessage);
            updateChatList(currMessage);
        }
    };

    const saveFiles = async (files, msgUuid, currMessage, connectionId, sendToId) => {
        if (!files || files.length === 0 || !msgUuid) {
            alert('Please select a file and enter a msgUuid.');
            return;
        }
    
        const formData = new FormData();
        // Append each file separately
        for (let i = 0; i < files.length; i++) {
            formData.append('files', files[i]);
        }
        formData.append('msgUuid', msgUuid);
        formData.append('connectionId', connectionId);
        formData.append('sendToId', sendToId);
    
        try {
            const response = await axios.post(`${configOpiton?.END_POINT}/communication/v1/message-exchange/wsmsg/file/upload`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': storage.getToken()
                },
            });
    
            if (response.status === 200) {
                console.log('File uploaded successfully:', response.data);
                
            }
        } catch (error) {
            console.error('Error uploading file:', error);
            showToast('error', 'Error', `${error} `)
        }
    };
    

    const handleSearchChatUser = (user) => {
        const { firstName, lastName, userId } = user;
        const chatItemList = JSON.parse(storage.get("chatGroup")) || [];
        const userName = firstName + " " + lastName;
        if (chatItemList.find((ch) => ch.chatId === userId) === undefined) {
            chatItemList.push({
                chatId: userId,
                message: "",
                msgTime: moment().format("YYYY-MM-DD HH:mm:ss"),
                groupChat: false,
                chatUserName: userName,
            });
            setChatGroupList(chatItemList);
            storage.set("chatGroup", JSON.stringify(chatItemList));
        }
    };

    const handleSelectedUser = (selectedItem) => {
        setSelectedChat(selectedItem);
    };
    return (
        <>
        {loading && <Loader />}
        <div className="w-full" style={{ height: "100vh" }}>
            <ChatHeader handleSearchChatUser={handleSearchChatUser} />
            <div className="flex flex-min-height">
                <Sidebar />
                <ChatList
                    messages={messageList}
                    handleSelectedUser={handleSelectedUser}
                    selectedChat={selectedChat}
                    connectionId={connectionId}
                    chatGroupList={chatGroupList}
                    ping={ping}
                />
                <div className="chat-area">
                    <MessageListPanel
                        messageList={messageList}
                        connectionId={connectionId}
                        selectedChat={selectedChat}
                        handlePing={handlePing}
                        getUserMessage={getUserMessage}
                    />
                    <div className="chat-input flex py-3 pr-4 pl-2 bg-white">
                        <ChatInput sendMessage={sendMessage} />
                    </div>
                </div>
            </div>
        </div>
        </>
    );
};

export default ChatInterface;
